module.exports = __webpack_public_path__ + "static/media/chidori.38019208.webp";